export default __webpack_public_path__ + "static/media/fight.be8f422c.png";